<style lang="less" scoped>
.dynamic-table-contain {
    border: solid 1px rgba(0,0,0,0.12);
    .header-common-value-tr {
        text-align: center;
    }
    .negative-red-dis {
      color: #ff3300;
    }
}
</style>
<template>
  <div class="dynamic-table-contain">
    <v-data-table
      dense
      disable-sort
      :headers="headers"
      :items="items"
      item-key="id"
      :items-per-page="Infinity"
      hide-default-footer
    >
      <template v-slot:[`item`]="{ item,headers }">
        <tr class="header-common-value-tr">
          <td 
            v-for="(header,header_index) in headers"
            :key="header_index"
            :style="{
              width:header.width,
              'min-width': header.width,
              'text-align':header._align
            }"
          >
            <div v-if="!item.is_sum">
              <span v-if="header.value==='title_id'">
                {{ item.title_name }}
              </span>
              <span 
                v-show="header.value!=='sum' && header.value!=='title_id'"
                :class="{'negative-red-dis':item[header.value]<0}"
              >
                {{ item[header.value]?formattingNumber(item[header.value],2) : '-' }}
              </span>
              <span 
                v-show="header.value==='sum'"
                :class="{'negative-red-dis':rowSum(item)<0}"
              >
                {{ rowSum(item)?formattingNumber(rowSum(item),2):'-' }}
              </span>
            </div>
            <div v-else>
              <span v-show="header.value==='title_id'">
                {{ item.title_name }}
              </span>
              <span
                v-if="header.value!=='title_id'&&header.value!=='sum'"
                :class="{'negative-red-dis':colSum(header.value)<0}"
              >
                {{ colSum(header.value)?formattingNumber(colSum(header.value),2):'-' }}
              </span> 
              <span 
                v-if="item.is_sum&&header.value==='sum'"
                :class="{'negative-red-dis':allSum()<0}"
              >
                {{ allSum()?formattingNumber(allSum(),2):'-' }}
              </span>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import { formattingNumber } from '../../../../libs/util'
  const except_key = ['title_id', 'title_name', 'sum', 'is_sum']
  export default {
    props: {
      tableData:{
        type: Array
      }
    },
    data() {
      return {
      }
    },
    computed:{
      headers() {
        const month_arr = []
        const month_hash = {}
        this.tableData.forEach(item => {
          const current_month = item.budget_month.slice(0, 7)
          if (month_hash[current_month]) {
            return 
          }
          month_hash[current_month] = true
          month_arr.push({
            text: current_month,
            align: 'end',
            _align: 'right',
            value: current_month,
          })
        })
        return [
          {
            text: '科目类别',
            align: 'center',
            _align: 'center',
            value: 'title_id',
          },
          ...month_arr,
          {
            text: '总计',
            align: 'end',
            _align: 'right',
            value: 'sum',
          }
        ]
      },
      items() {
        let arr = []
        const title_id_hash = {}
        this.tableData.forEach(item => {
          const month = item.budget_month.slice(0, 7)
          if (!title_id_hash[item.title_id]) {
            title_id_hash[item.title_id] = {
              title_id:item.title_id,
              title_name: item.title_name
            }
          }
          title_id_hash[item.title_id][month] = Number(item.budget_amount)
        })
        arr = Object.keys(title_id_hash).map(key => title_id_hash[key])
        arr.push({
          title_id:'all',
          title_name: '总计',
          is_sum:true
        })
        return arr
      }
    },
    methods: {
      formattingNumber,
      rowSum(item) {
        let sum = 0
        Object.keys(item).forEach((key) => {
          if (except_key.includes(key)) {
            return 
          }
          sum = math.eval(`${sum}+${item[key] || 0}`)
        })
        return Number(sum) 
      },
      colSum(key) {
        let sum = 0
        this.items.forEach(item => {
          sum = math.eval(`${sum}+${item[key] || 0}`)
        }) 
        return Number(sum) 
      },
      allSum() {
        let sum = 0
        this.items.forEach(item => {
          Object.keys(item).forEach(key => {
            if (except_key.includes(key)) {
              return 
            }
            sum = math.eval(`${sum}+${item[key] || 0}`)
          })
        })
        return Number(sum)
      }
    }
  }
</script>